import List from 'containers/Inventory/List';

export default { List };
